/**
 * 统一管理
 * 从 cookie 中获取数据
 */
import Cookies from 'js-cookie';

// 获取用户名
export const getUserName = () => Cookies.get('bce-login-display-name');

// 获取accountId
// 注意目前bce-session值获取不到，因为他是httponly的，该方法暂时不可用
export const getAccountId = () => Cookies.get('bce-session');

// 获取baiduid
export const getBaiduId = () => Cookies.get('BAIDUID');